import React from "react";
import { Header } from "../../components/Header";
import { AboutusBanner } from "../../blocks/aboutus-banner";
import { AboutusContent } from "../../blocks/aboutus-content";
import { Contact } from "../../blocks/common-contact";
// import { AboutusContact } from "../../blocks/aboutus-contact";
import { AboutusLinks } from "../../blocks/aboutus-links";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { Footer } from "../../components/Footer";

export const AboutusPage = () => {
  const { t } = useTranslation();
  return (
    <div className="aboutus-page">
      <Header mode={"light"} />
      <AboutusBanner />
      <AboutusContent />
      {/* <AboutusContact /> */}
      <Contact
        title={t("about.form.title")}
        subtitle={t("about.form.subtitle")}
      />
      <AboutusLinks />
      <Footer />
    </div>
  );
};
